export default __webpack_public_path__ + "static/media/problema-02.5f258089.webp";